import axios from 'axios';
import axiosRetry from 'axios-retry';
import Vue from "vue";

const http = axios.create({
  timeout: 3000,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
});

http.interceptors.request.use(
  (config) => {
    config.baseURL = window.vue.$store.state.apiURL;
    config.headers.common['Session-Token'] = window.vue.$cookies.get("adminToken");
    config.headers.common['Api-Key'] = process.env.VUE_APP_API_TOKEN;
    return config;
  }, (error) => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // nincs bejelentkezve
    if (error.response.status === 401) {
      window.vue.$router.push('/home').catch(()=>{});
    }

    // nincs jogosultság
    if (error.response.status === 403) {
      console.log("403");
      window.vue.$router.push('/adminlogin/hu').catch(()=>{});
    }

    // egyéb hiba
    if (error.response.status === 404) {
      console.log("404 Nincs");
      //window.vue.$store.dispatch('setSnackBar', { msg: error.response.data.message, type: 'error' });
    }

    return Promise.reject(error.response);
  }
);

Vue.prototype.$http = http;
Vue.prototype.$axios = axios;

export default http;